import {
    UWM_AMPLITUDE_TRACKING,
    UWM_MODULE_BACK_BUTTON_CLICK,
    UWM_MODULE_DATA_RECEIVED_SUCCESS,
    UWM_MODULE_INITIALIZATION_ERROR,
    UWM_MODULE_LOADED,
    UWM_MODULE_LOADING_END,
    UWM_MODULE_LOADING_START,
    UWM_MODULE_MEDIA_CACHED,
    UWM_MODULE_NAVIGATE_TO_WIFI_GUIDE,
    UWM_MODULE_PAGE_OPENED,
} from '@/consts/eventTypes';
import {TIPS_PAGE_TYPES} from '@/consts/tipsTypes';

const sendMessageToParent = (payload: any) => {
    window.parent.postMessage(
        {
            detail: {
                command: 'UwmEvent',
                payload,
            },
        },
        '*'
    );
};

const sendLoadedMessageToParent = () => {
    sendMessageToParent({
        type: UWM_MODULE_LOADED,
    });
};

const sendDataSuccessReceivedMessage = () => {
    sendMessageToParent({
        type: UWM_MODULE_DATA_RECEIVED_SUCCESS,
    });
};

const sendMediaCachedMessage = () => {
    sendMessageToParent({
        type: UWM_MODULE_MEDIA_CACHED,
    });
};

const sendModuleInitializationError = (message: string) => {
    sendMessageToParent({
        type: UWM_MODULE_INITIALIZATION_ERROR,
        message,
    });
};

const sendBackButtonTriggerMessage = () => {
    sendMessageToParent({
        type: UWM_MODULE_BACK_BUTTON_CLICK,
    });
};

const trackAmplitude = (eventType?: string) => {
    if (!eventType) return;

    sendMessageToParent({
        type: UWM_AMPLITUDE_TRACKING,
        eventType,
    });
};

const sendNavigateToWifiGuide = () => {
    sendMessageToParent({
        type: UWM_MODULE_NAVIGATE_TO_WIFI_GUIDE,
    });
};

const sendModuleLoadingStart = () => {
    sendMessageToParent({
        type: UWM_MODULE_LOADING_START,
    });
};

const sendModuleLoadingEnd = () => {
    sendMessageToParent({
        type: UWM_MODULE_LOADING_END,
    });
};

const sendTipsListOpened = () => {
    sendMessageToParent({
        type: UWM_MODULE_PAGE_OPENED,
        pageType: TIPS_PAGE_TYPES.TIPS_LIST,
    });
};

const sendTipOpened = (guideItemType: string) => {
    sendMessageToParent({
        type: UWM_MODULE_PAGE_OPENED,
        pageType: TIPS_PAGE_TYPES.TIP,
        guideItemType,
    });
};

const sendButtonAction = (action: string, metadata?: Record<string, unknown>) => {
    const payload = {
        type: action,
        ...metadata,
    };
    sendMessageToParent(payload);
};

export default {
    sendMessageToParent,
    sendLoadedMessageToParent,
    sendDataSuccessReceivedMessage,
    sendMediaCachedMessage,
    sendModuleInitializationError,
    sendBackButtonTriggerMessage,
    trackAmplitude,
    sendNavigateToWifiGuide,
    sendModuleLoadingStart,
    sendModuleLoadingEnd,
    sendTipsListOpened,
    sendTipOpened,
    sendButtonAction,
};
